import { NavMarker } from 'react-rhumb';
import ErrorPage from '../error/ErrorPage';
import { useProfileRedirects } from './ProfileRedirects';
import { jsx as _jsx } from "react/jsx-runtime";
const ProfileNotFound = ({
  objectType,
  objectId
}) => {
  const isMaybeRedirecting = useProfileRedirects({
    objectType,
    subjectId: objectId
  });
  if (isMaybeRedirecting) {
    return null;
  }
  return /*#__PURE__*/_jsx(ErrorPage, {
    errorCode: "404",
    RhumbMarker: /*#__PURE__*/_jsx(NavMarker, {
      name: "RECORD_NOT_FOUND"
    })
  });
};
export default ProfileNotFound;